var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8125 8.70459C0.8125 4.28631 4.39422 0.70459 8.8125 0.70459H32.8125C37.2308 0.70459 40.8125 4.28631 40.8125 8.70459V32.7046C40.8125 37.1229 37.2308 40.7046 32.8125 40.7046H8.8125C4.39422 40.7046 0.8125 37.1229 0.8125 32.7046V8.70459Z",
    fill: "#F5F2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0318 21.7319C29.2772 21.0036 30.0671 20.6126 30.7945 20.8578H30.7935C31.5219 21.1033 31.913 21.894 31.6676 22.6215C30.2961 26.6856 25.7228 29.7034 20.9791 29.7036C20.9239 29.7036 20.8681 29.7044 20.8121 29.7036C16.0167 29.7701 11.3452 26.7336 9.9576 22.6215C9.71211 21.8931 10.1031 21.1033 10.8306 20.8578C11.5581 20.6124 12.3479 21.0044 12.5933 21.7319C13.5956 24.7033 17.2019 26.9836 20.7896 26.9213H20.8365C24.4321 26.9825 28.0285 24.7032 29.0318 21.7319ZM15.0855 11.7045C16.4178 11.7046 17.4976 12.7853 17.4976 14.1176C17.4976 15.4498 16.4178 16.5296 15.0855 16.5297C13.7532 16.5297 12.6734 15.45 12.6734 14.1176C12.6734 12.7853 13.7532 11.7045 15.0855 11.7045ZM26.5396 11.7045C27.8718 11.7048 28.9517 12.7854 28.9517 14.1176C28.9517 15.4498 27.8718 16.5295 26.5396 16.5297C25.2073 16.5297 24.1275 15.45 24.1275 14.1176C24.1275 12.7853 25.2073 11.7045 26.5396 11.7045Z",
    fill: "#914DE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.06a8a0870304e56a659b67d77fcc0b4a.svg";
export { ForwardRef as ReactComponent };